import { getDefaultState } from './default'

import {
  WARRANTY_CLEAR_MODULE,
  WARRANTY_UPDATE_CREATED,
  WARRANTY_UPDATE_SINISTER_ID,
  WARRANTY_UPDATE_SECONDARY_ID,
  WARRANTY_UPDATE_ZIP_CODE,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE,
  WARRANTY_UPDATE_SINISTER_SUMMARY,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_MATERIAL_SUMMARY,
  WARRANTY_UPDATE_REPAIR_TYPE,
  WARRANTY_UPDATE_HEIGHT,
  WARRANTY_UPDATE_WIDTH,
  WARRANTY_UPDATE_UNIT,
  WARRANTY_UPDATE_LAST_PIECE_SELECTED,
  WARRANTY_UPDATE_PIECES_SURFACE,
  WARRANTY_UPDATE_SHOW_EXTRA_INFO,
  WARRANTY_EXISTING_SINISTER,
  WARRANTY_UPDATE_ANSWERED_EXTRA_INFO
} from '@/store/types'

export default {
  [WARRANTY_UPDATE_REPAIR_TYPE](state, payload) {
    state.repairType = payload
  },
  [WARRANTY_CLEAR_MODULE](state, payload) {
    Object.assign(state, getDefaultState())
  },
  [WARRANTY_UPDATE_CREATED](state, payload) {
    state.created = typeof payload === 'boolean' ? payload : false
  },
  [WARRANTY_UPDATE_SINISTER_ID](state, payload) {
    state.sinisterId = payload
  },
  [WARRANTY_UPDATE_SECONDARY_ID](state, payload) {
    state.secondaryId = payload
  },
  [WARRANTY_UPDATE_ADDRESS](state, payload) {
    state.address = payload
  },
  [WARRANTY_UPDATE_ZIP_CODE](state, payload) {
    state.zipCode = payload
  },
  [WARRANTY_UPDATE_COORDINATES](state, payload) {
    state.coordinates = payload
  },
  [WARRANTY_UPDATE_MORE_THAN_TWO_YEARS](state, payload) {
    state.moreThanTwoYears = payload
  },
  [WARRANTY_UPDATE_SHOW_EXTRA_INFO](state, payload) {
    state.showExtraInfo = payload
  },
  [WARRANTY_UPDATE_PROPERTY_TYPE](state, payload) {
    state.propertyType = payload
  },
  [WARRANTY_UPDATE_RESIDENT_TYPE](state, payload) {
    state.residentType = payload
  },
  [WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE](state, payload) {
    state.damage.rep_type_code = payload
  },
  [WARRANTY_UPDATE_SINISTER_SUMMARY](state, payload) {
    // checks if there is no update in the items
    if (JSON.stringify(state.sinisterSummary) === JSON.stringify(payload)) {
      return
    }
    state.sinisterSummary = payload.splice(0)
  },
  [WARRANTY_UPDATE_REPORT](state, payload) {
    state.report = payload
  },
  [WARRANTY_UPDATE_MATERIAL_SUMMARY](state, payload) {
    state.materialSummary = payload
  },
  [WARRANTY_UPDATE_HEIGHT](state, payload) {
    state.heightArea = payload
  },
  [WARRANTY_UPDATE_WIDTH](state, payload) {
    state.widthArea = payload
  },
  [WARRANTY_UPDATE_UNIT](state, payload) {
    state.unitArea = payload
  },
  [WARRANTY_UPDATE_LAST_PIECE_SELECTED](state, payload) {
    state.lastPieceSelected = payload
  },
  [WARRANTY_UPDATE_PIECES_SURFACE](state, payload) {
    state.piecesSurface = payload
  },
  [WARRANTY_EXISTING_SINISTER](state, payload) {
    state.existingSinister = payload
  },
  [WARRANTY_UPDATE_ANSWERED_EXTRA_INFO](state, payload) {
    state.answeredExtraInfo = payload
  }
}
